import * as HttpRequest from "EstruturaAntiga/assets/httpRequest";
import { mapUserFieldsV2toV1 } from "EstruturaAntiga/assets/userHelpers";
import ContatosService from 'services/ContatosService';
import CONSTANTES_AMBIENTE from 'constants/constantesAmbiente';
import { NotificationManager } from 'react-notifications';
import { MessagesDefaultTimeout } from 'constants/messagesDefaultTimeout';
import UsuariosService from 'services/UsuariosService';

export const rdxGetUserEditarMeusDados = async () => {
    const user = HttpRequest.adalUser().profile;
    var tenantCodeGerenciado = await obterTenantCodeGerenciado(user.upn);
    if (tenantCodeGerenciado) {
        return dispatch => (UsuariosService.ObterUsuario(user.upn, tenantCodeGerenciado).then(obj => {
            dispatch({ type: 'ALTERAR_DADOS_GET_USER_INFO', payload: mapUserFieldsV2toV1(obj, tenantCodeGerenciado) })
        }));
    } else {
        return dispatch => {
            dispatch({ type: 'ALTERAR_DADOS_GET_USER_INFO', payload: obterInformacaoTabelaContato() });
        };
    }
};

const obterTenantCodeGerenciado = async (upn) => {
    if (!upn) return false;
    const lowerUpn = upn.toLowerCase();
    const mapaDominios = CONSTANTES_AMBIENTE.TENANT_CODE_POR_DOMINIO_UPN;

    for (const dominio in mapaDominios) {
        if (lowerUpn.endsWith(dominio)) {
            return mapaDominios[dominio];
        }
    }
    const usuario365 = await UsuariosService.ObterUsuario365PorUsuarioAutenticado();
    return usuario365?.tenantCode || false;
};

const obterInformacaoTabelaContato = async () => {
    const contato = JSON.parse(sessionStorage.getItem('contact'));
    var contatoUsuarioLogado = await ContatosService.ObterContato(contato.idContact);
    return {
        axt_displayname365: contatoUsuarioLogado.nomeParaExibicao,
        emailaddress2: contatoUsuarioLogado.emailAlternativo,
        telephone1: contatoUsuarioLogado.telefoneComercial,
        mobilephone: contatoUsuarioLogado.telefone,
        contatoId: contatoUsuarioLogado.contatoId
    }
}

export const rdxClearDados = editable => ({
    type: 'ALTERAR_DADOS_CLEAR',
    payload: editable
})